module.exports = __webpack_public_path__ + "img/cooperation_unit_17.f8af7e7c.jpg";